import axiosInstance from './axiosInstance';

/**
 * Notifications and push registration.
 *
 * Two concerns in one client because they are one feature from the app's side: the
 * bell reads notifications, and enabling push is something you do from the same screen.
 * The server keeps them apart — the record is written whether or not push works.
 */

/** The caller's own notifications plus the unread count, in one request. */
export const fetchNotificationsApi = async () => {
    const response = await axiosInstance.get('/notifications');
    return response.data;
};

export const markNotificationReadApi = async (uuid) => {
    await axiosInstance.post(`/notifications/${uuid}/read`);
    return uuid;
};

export const markAllNotificationsReadApi = async () => {
    await axiosInstance.post('/notifications/read-all');
};

/**
 * The VAPID public key a browser must bind its subscription to, and whether push is
 * configured at all. `enabled: false` is a normal answer — it means no key pair is
 * set up in this environment, and the app hides the prompt rather than offering a
 * button that cannot work.
 */
export const fetchPushPublicKeyApi = async () => {
    const response = await axiosInstance.get('/push/subscriptions/public-key');
    return response.data;
};

/**
 * ⚠️ No staff uuid in the body. The server takes the owner from the token — sending
 * one would let a signed-in user point someone else's notifications at their device.
 */
export const registerPushSubscriptionApi = async ({ endpoint, p256dh, auth, userAgent }) => {
    await axiosInstance.post('/push/subscriptions', { endpoint, p256dh, auth, userAgent });
};

export const removePushSubscriptionApi = async (endpoint) => {
    await axiosInstance.delete('/push/subscriptions', { data: { endpoint } });
};
